import {
  PUBLICATION_MODE_ENV_NAME,
  resolveConfiguredPublicationMode,
} from '../../shared/publicationMode.js';

export const getClientConfiguredPublicationMode = (env = import.meta.env) =>
  resolveConfiguredPublicationMode(env?.[PUBLICATION_MODE_ENV_NAME]);

export const getClientPublicationModeValue = (env = import.meta.env) =>
  env?.[PUBLICATION_MODE_ENV_NAME];

export const CLIENT_PUBLICATION_MODE_VALUE = getClientPublicationModeValue();
export const CLIENT_CONFIGURED_PUBLICATION_MODE = getClientConfiguredPublicationMode();
